// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__5Rs81","title":"Images45_title__1CLmM","images":"Images45_images__1PUTv"};